<template>
  <RemotePaginatedList :hide-search="hideSearch"
                       :filter-options="filterOptions"
                       :headers="headers"
                       multi-sort
                       :show-select="showSelect"
                       v-model="selectedItemIds"
                       data-url="aafb/admin/item_type/"
                       data-key="item_types"
                       :refresh-trigger.sync="innerRefreshTrigger"
                       v-bind="$attrs">
    <template v-slot:item.actions="{item}">
      <v-menu offset-y
              rounded
              left>
        <template v-slot:activator="{on}">
          <v-btn icon
                 v-on="on">
            <v-icon>fas fa-cog</v-icon>
          </v-btn>
        </template>
        <v-list class="pa-2">
          <v-list-item @click="editItem(item)">
            <v-icon>fas fa-search</v-icon>
            <label class="ml-3 font-weight-medium">{{ $t('detail') }}</label>
          </v-list-item>
          <v-list-item @click="regenerateSessions(item)">
            <v-icon>fas fa-sync</v-icon>
            <label class="ml-3 font-weight-medium">{{ $t('admin_acc_item_type.regenerate_sessions') }}</label>
          </v-list-item>
          <v-list-item @click="deleteItem(item)">
            <v-icon>fas fa-trash</v-icon>
            <label class="ml-3 font-weight-medium">{{ $t('delete') }}</label>
          </v-list-item>
        </v-list>
      </v-menu>
    </template>
  </RemotePaginatedList>
</template>

<script>
import _ from 'lodash';
import {computed, onMounted, ref, watch} from '@vue/composition-api'
import RemotePaginatedList from "@/components/RemotePaginatedList";

export default {
  name: 'ItemTypeList',
  components: {RemotePaginatedList},
  props: {
    value: Array,
    hideSearch: Boolean,
    showSelect: Boolean,
    refreshTrigger: Boolean,
  },
  setup(props, {root, emit}) {
    const refresh = function () {
      innerRefreshTrigger.value = true;
    };
    onMounted(() => {
      refresh();
    });

    watch(() => props.refreshTrigger, (newValue) => {
      if (newValue) {
        refresh();
        emit('update:refresh-trigger', false);
      }
    })

    // Filter
    const filterOptions = computed(() => {
      return [
        {text: root.$t('admin_acc_facility_type.name_en'), value: 'name_en', contains: true},
        {text: root.$t('admin_acc_facility_type.name_zh'), value: 'name_zh', contains: true},
      ]
    })

    // Data Table
    const headers = ref([
      {text: root.$t('admin_acc_facility_type.name_en'), value: 'name_en'},
      {text: root.$t('admin_acc_facility_type.name_zh'), value: 'name_zh'},
      {text: '', value: 'actions'},
    ]);
    const innerRefreshTrigger = ref(false);

    const selectedItemIds = ref([]);
    watch(() => selectedItemIds.value, (newValue) => {
      emit('input', newValue);
    });

    watch(() => props.value, (newValue, oldValue) => {
      if (_.xor(newValue, oldValue).length) {
        selectedItemIds.value = newValue;
      }
    }, {deep: true, immediate: true})

    const editItem = function (item) {
      emit('edit', item);
    };
    const regenerateSessions = function (item) {
      if (confirm(root.$t('admin_acc_facility_type.confirm_reset_msg'))) {
        root.$callAPI('room/admin/item_type/regenerate_sessions/', {type_id: item.id}, function () {
          refresh();
        })
      }
    }
    const deleteItem = function (item) {
      if (confirm(root.$t('admin_acc_facility_type.confirm_delete_msg'))) {
        root.$callAPI('aafb/admin/item_type/delete/', {type_id: item.id}, function () {
          refresh()
        })
      }
    };


    return {
      filterOptions,

      headers,
      innerRefreshTrigger,
      selectedItemIds,

      editItem,
      regenerateSessions,
      deleteItem,
    }
  }
}
</script>
